import { Role } from '../../../shared/enum';

export const getRoleLabel = (role: Role) => {
  switch (role) {
    case Role.FullAdmin:
      return 'NBI Full Admin';
    case Role.RestrictedAdmin:
      return 'NBI Restricted Admin';
    case Role.User:
      return 'NBI User';
    case Role.DECC:
      return 'DECC';
    case Role.RSP:
      return 'RSP User';
    case Role.IndependentAuditor:
      return 'Independent Certifier';
  }
};

export const getRoleHelpText = (role: Role) => {
  switch (role) {
    case Role.FullAdmin:
    case Role.RestrictedAdmin:
      return 'Document management, user management and document approvals';
    case Role.User:
      return 'Document management';
    default:
      return 'View approved documents';
  }
};
